module.exports = __webpack_public_path__ + "img/icon-star-three-quarter.ebe99030.svg";